import { RouteObject } from "react-router-dom";
import { AllTokens } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";
import {
  RAG_DOCUMENTS_PATH,
  RagDocumentsPage,
} from "@/modules/ai/pages/rag-documents";
import {
  AI_TOKEN_USAGE_PATH,
  AiTokenUsagePage,
} from "@/modules/ai/pages/ai-token-usage";

export const aiRoutes: RouteObject[] = [
  {
    path: RAG_DOCUMENTS_PATH,
    element: <RagDocumentsPage />,
  },
  {
    path: AI_TOKEN_USAGE_PATH,
    element: (
      <Guard.Redirect.IfCantModify.PageNotFound
        influencedBy={[AllTokens.AdminAiTokenUsageStatistics]}
      >
        <AiTokenUsagePage />
      </Guard.Redirect.IfCantModify.PageNotFound>
    ),
  },
];
